import { withFormik, Field } from 'formik'
import React, { useState, useEffect, useRef } from 'react'
import { BackgroundSignUp } from '../newsignup/BackgroundSignUp'
import { Progress } from '../newsignin/Progress'
import { Steps } from '../newsignupcreateaccount/Steps'
import CreateBrandForm from './CreateBrandForm'
import _get from 'lodash/get'
import _set from 'lodash/set'
import { withRouter } from 'react-router'
import { newBrand } from '../../../_common/core/http_services/signup'
import { NotificationError } from '../newsignin/NotificationError'
import { connect } from 'react-redux'
import { Titles } from '../newsignin/Titles'
import { FixedAddressField } from '../../formik/Fields/FixedAddressField'
import { Logo } from '../newsignin/Logo'
import _sortBy from 'lodash/sortBy'
import _map from 'lodash/map'
import _entries from 'lodash/entries'
import { useMediaQuery } from '../../../_common/core/utils'
import { SET_HAS_BRANDS } from '../../../_common/redux/brands/actions'
import { parsePlaceResult } from '../../events/form/EventForm/utils'
import { PreLoader } from '../../_library/PreLoader'
import { movedToTeamInvitations } from '../../../_common/core/gtag'
import { getStripeCountries } from '../../../_common/core/http_services'
import { brandsReferralsUpdateToken } from '../../../_common/core/http_services/refferers'

const stripeData = {
  26: 'Albania',
  27: 'Algeria',
  30: 'Angola',
  33: 'Antigua and Barbuda',
  34: 'Argentina',
  35: 'Armenia',
  3: 'Australia',
  11: 'Austria',
  37: 'Azerbaijan',
  38: 'Bahamas',
  39: 'Bahrain',
  40: 'Bangladesh',
  12: 'Belgium',
  44: 'Benin',
  46: 'Bhutan',
  47: 'Bolivia, Plurinational State of',
  48: 'Bosnia and Herzegovina',
  49: 'Botswana',
  51: 'Brazil',
  53: 'Brunei Darussalam',
  54: 'Bulgaria',
  57: 'Cambodia',
  2: 'Canada',
  63: 'Chile',
  67: 'Colombia',
  72: 'Costa Rica',
  73: "Cote d'Ivoire",
  74: 'Croatia',
  76: 'Cyprus',
  14: 'Czech Republic',
  15: 'Denmark',
  79: 'Dominican Republic',
  80: 'Ecuador',
  81: 'Egypt',
  85: 'Estonia',
  86: 'Ethiopia',
  13: 'Finland',
  4: 'France',
  93: 'Gabon',
  94: 'Gambia',
  5: 'Germany',
  96: 'Ghana',
  97: 'Gibraltar',
  98: 'Greece',
  103: 'Guatemala',
  107: 'Guyana',
  112: 'Hong Kong',
  113: 'Hungary',
  6: 'Iceland',
  114: 'India',
  115: 'Indonesia',
  7: 'Ireland',
  118: 'Israel',
  8: 'Italy',
  119: 'Jamaica',
  120: 'Japan',
  122: 'Jordan',
  123: 'Kazakhstan',
  124: 'Kenya',
  127: 'Korea, Republic of',
  128: 'Kuwait',
  130: "Lao People's Democratic Republic",
  131: 'Latvia',
  136: 'Liechtenstein',
  137: 'Lithuania',
  138: 'Luxembourg',
  139: 'Macao',
  140: 'Macedonia',
  141: 'Madagascar',
  143: 'Malaysia',
  146: 'Malta',
  150: 'Mauritius',
  152: 'Mexico',
  154: 'Moldova, Republic of',
  155: 'Monaco',
  156: 'Mongolia',
  159: 'Morocco',
  160: 'Mozambique',
  162: 'Namibia',
  22: 'Netherlands',
  19: 'New Zealand',
  168: 'Niger',
  169: 'Nigeria',
  16: 'Norway',
  173: 'Oman',
  174: 'Pakistan',
  177: 'Panama',
  179: 'Paraguay',
  180: 'Peru',
  181: 'Philippines',
  183: 'Poland',
  21: 'Portugal',
  185: 'Qatar',
  187: 'Romania',
  192: 'Saint Lucia',
  204: 'Singapore',
  205: 'Slovakia',
  206: 'Slovenia',
  9: 'Spain',
  211: 'Sri Lanka',
  10: 'Sweden',
  18: 'Switzerland',
  220: 'Thailand',
  233: 'United Arab Emirates',
  17: 'United Kingdom',
  1: 'United States',
}

const CreateBrandPage = ({ history, location: { state }, isRnDomain, ...props }) => {
  const [loadingUser, setLoadingUser] = useState(true)
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        if (
          !state.createBrandOnly &&
          (!state?.email || !state?.lastName || !state?.firstName || !state?.best_describe)
        ) {
          history.push('/welcome/create-account')
          return
        }
        const countries = await getStripeCountries()
        setCountries(
          _sortBy(
            _map(_entries(countries), ([key, value]) => ({
              value: String(key),
              label: value,
            })),
            'label',
          ),
        )
        setLoadingUser(false)
      } catch (e) {
        setCountries(
          _sortBy(
            _map(_entries(stripeData), ([key, value]) => ({
              value: String(key),
              label: value,
            })),
            'label',
          ),
        )
        setLoadingUser(false)
      }
    }
    fetchCountries()
  }, [history, state])
  const [countries, setCountries] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)
  const AutocompleteService = useRef(global.google ? new google.maps.places.AutocompleteService() : null)
  useEffect(() => {
    const interval = setInterval(() => {
      if (!AutocompleteService?.current) {
        AutocompleteService.current = global.google ? new google.maps.places.AutocompleteService() : null
      } else {
        clearInterval(interval)
      }
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])
  const [suggestions, setSuggestions] = useState([])
  const setError = () => {
    const { setFieldValue } = props
    setFieldValue('error', '')
  }
  const {
    values: { error },
    setFieldValue,
  } = props
  const onClickOption = suggestion => {
    const statuses = google.maps.places.PlacesServiceStatus
    const PlacesService = new google.maps.places.PlacesService(ref.current)
    PlacesService?.getDetails({ placeId: suggestion.place_id }, (res, status) => {
      let err
      if (status === statuses.ZERO_RESULTS) {
        err = 'No address found for venue'
      } else if (status !== statuses.OK) {
        err = 'Unexpected error occurred while looking up venue address'
      }
      if (err) {
        setFieldValue('address', '')
        setFieldValue('error', err)
        return
      }
      const { city, postalCode, state } = parsePlaceResult(res, {
        isRnDomain: false,
        autoDefineVenue: false,
        useLongNames: true,
        useCountryShortName: true,
      })
      const { address_components } = res
      const countryService = address_components.find(component => component.types.includes('country'))
      if (countryService) {
        const countryName = countryService.long_name
        const countryId = countries.find(country => countryName === country.label)?.value
        const countryCode = countryService.short_name
        setFieldValue('countryId', Number(countryId))
        setFieldValue('countryCode', countryCode)
        setFieldValue(
          'address',
          address_components
            .filter(
              address =>
                !(
                  address.types.includes('administrative_area_level_1') ||
                  address.types.includes('country') ||
                  address.types.includes('locality') ||
                  address.types.includes('postal_code')
                ),
            )
            .reduce((curr, next) => curr + next.long_name + ', ', '')
            .slice(0, -2),
        )
      }
      if (city) {
        setFieldValue('city', city)
      }
      if (state) {
        setFieldValue('stateName', state)
      }
      if (postalCode) {
        setFieldValue('zip', postalCode)
        setFieldValue('showZipField', false)
      } else {
        setFieldValue('zip', '')
        setFieldValue('showZipField', true)
      }
    })
    setSuggestions([])
    setShowDropdown(false)
  }
  const onClickBack = () => {
    setShowDropdown(false)
  }
  const onClickCancel = () => {
    setFieldValue('address', '')
  }
  const getSuggestions = e => {
    const { value } = e.target
    const statuses = google.maps.places.PlacesServiceStatus
    AutocompleteService?.current?.getPlacePredictions(
      { input: value, types: ['address'] },
      (suggestions, status) => {
        if (status === statuses.ZERO_RESULTS) {
          return
        } else if (status !== statuses.OK) {
          return
        }
        setSuggestions(suggestions)
      },
    )
  }
  const optionComponent = (suggestion, i) => (
    <div className="suggestion" key={i} onClick={() => onClickOption(suggestion)}>
      <img
        alt=""
        src={asset('/resources/images/marker-map-dot.svg')}
        className="fa-map-marker-dot color-svg-map-marker"
      />
      <img
        alt=""
        src={asset('/resources/images/marker-map.svg')}
        className="color-svg-map-marker"
        style={{ position: 'absolute', left: 20, top: 17 }}
      />
      <div style={{ width: 'calc(100% - 48px)' }}>
        <div className="suggestion-description">{suggestion.description.split(',')[0]}</div>
        <div className="suggestion-details">
          {suggestion.description.split(',').reduce((curr, next, i) => {
            if (i === 0) {
              return curr
            }
            return curr + (i === 1 ? '' : ',') + next
          }, '')}
        </div>
      </div>
    </div>
  )
  const ref = useRef(null)
  const isMobile = useMediaQuery('(max-width: 768px)')
  return loadingUser ? (
    <PreLoader isRnDomain={isRnDomain} />
  ) : (
    <div className="absolute-container create-brand">
      <div ref={ref} />
      <Logo />
      <Progress width="40%" />
      <Titles text={isMobile ? 'Sign Up as an Event Organizer' : undefined} />
      <Steps
        elements={[
          {
            classNameText: 'step-text-finished',
            classNameIcon: 'step-finished',
            text: isMobile ? 'Account' : 'Create Your Account',
            iconChildren: <i className="fa fa-check" />,
          },
          {
            classNameText: 'step-text-current',
            classNameIcon: 'step-current',
            text: isMobile ? 'Brand' : 'Create Your Brand',
            iconChildren: '2',
          },
          {
            classNameText: 'step-text-next',
            classNameIcon: 'step-next',
            text: isMobile ? 'Team' : 'Invite Your Team',
            iconChildren: '3',
          },
          {
            classNameText: 'step-text-next',
            classNameIcon: 'step-next',
            text: 'Payout Mode',
            iconChildren: '4',
          },
        ]}
      />
      {showDropdown && (
        <Field
          type="address"
          name="address"
          onClickBack={onClickBack}
          onClickCancel={onClickCancel}
          component={FixedAddressField}
          options={suggestions}
          onChange={getSuggestions}
          optionComponent={optionComponent}
          autoComplete="off"
        />
      )}
      {error ? <NotificationError error={error} setError={setError} /> : null}
      <BackgroundSignUp>
        <CreateBrandForm
          setShowDropdown={setShowDropdown}
          {...props}
          AutocompleteService={AutocompleteService}
          suggestions={suggestions}
          setSuggestions={setSuggestions}
          countries={countries}
          onClickOption={onClickOption}
          getSuggestions={getSuggestions}
          history={history}
          state={state}
        />
      </BackgroundSignUp>
    </div>
  )
}

const CreateAccountFormFormik = withFormik({
  mapPropsToValues: props => ({
    email: '',
    address: '',
    legalEntity: '',
    displayName: '',
    countryId: '',
    countryCode: '',
    stateName: '',
    zip: '',
    error: '',
    city: '',
    showZipField: false,
    parentId: props?.location?.state?.parentId || '',
  }),
  validate: values => {
    const errors = {}
    if (!_get(values, 'countryCode')) {
      _set(errors, 'address', 'Please, make sure you have selected the address from the list')
    }
    return errors
  },
  handleSubmit: async (values, { props, setSubmitting, setFieldValue }) => {
    const state = props?.location?.state
    delete values.error
    delete values.showZipField
    try {
      const brand = await newBrand({
        data: {
          attributes: values,
          type: 'organization',
        },
      })
      try {
        if (state?.referral) {
          await brandsReferralsUpdateToken(state.referral, state.user_id, brand?.data?.id)
        }
      } catch {}
      setSubmitting(false)
      localStorage.removeItem('createAccountState')
      localStorage.setItem('signUpBrandId', String(brand?.data?.id))
      props.history.push(
        state.createBrandOnly ? '/brand/new/team-invitations' : '/welcome/team-invitations',
        { brandId: brand?.data?.id, createBrandOnly: state.createBrandOnly },
      )
      movedToTeamInvitations(values.displayName)
      props.SET_HAS_BRANDS(true)
      isProd() && fbq('trackCustom', 'CustomerCreatedBrandSuccesfully', { brandId: brand?.data?.id })
    } catch (e) {
      const error = _get(e, 'response.data.message')
      if (error) {
        setFieldValue('error', error)
      }
      setSubmitting(false)
    }
  },

  displayName: 'CreateAccountForm',
})(CreateBrandPage)

const CreateAccountFormRedux = connect(
  state => {
    const { isRnDomain } = state.shared
    return {
      isRnDomain,
    }
  },
  { SET_HAS_BRANDS },
)(CreateAccountFormFormik)

const CreateAccountFormRouter = withRouter(CreateAccountFormRedux)

export { CreateAccountFormRouter }
